// Function to check if the user is on a mobile device
export function isMobile() {
    return window.innerWidth <= 1200;
  };